import React from 'react';

const NotFoundPage: React.FC = () => (
  <div className="h-full flex flex-col items-center justify-center gap-3">
    <h1>¯\_(ツ)_/¯</h1>
    <h2>Ticker Not Found</h2>
  </div>
);

export default NotFoundPage;
